import { createSelector } from "reselect";
import getOsVersionFloat from "selectors/device/getOsVersionFloat";
import getIsAndroid from "selectors/device/getIsAndroid";

export default createSelector(
  getOsVersionFloat,
  getIsAndroid,
  (osVersionFloat, isAndroid) =>
    isAndroid && !!osVersionFloat && osVersionFloat < 4.4,
);
